// extracted by mini-css-extract-plugin
module.exports = {"container":"fg-z","creativeContainer":"gg-z","copy":"hg-z","cta":"ig-z","disabled":"jg-z","flipped":"kg-z","card":"lg-z"};